module.exports = __webpack_public_path__ + "static/media/cd.ed47822b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cd.svg
// module id = 81
// module chunks = 0